export default [
  {
    component: () => import("@/components/sobre/versao.vue"),
    name: "sobre.versao",
    path: "/sobre/versao",
    label: "Versão",
  },
];
